// "Day-One Priorities" cards shown on the profile screen. Extracted verbatim.

export interface FirstDayPriority {
  icon: string;
  ar: { title: string; desc: string };
  en: { title: string; desc: string };
}

export const firstDayPriorities: FirstDayPriority[] = [
  {
    icon: "/icons/outlook.png",
    ar: { title: "البريد الإلكتروني و Outlook", desc: "سجّل دخولك إلى برنامج Outlook بحسابك في الشركة وتأكد من وصول الرسائل." },
    en: { title: "Email & Outlook", desc: "Sign in to the Outlook app with your company account and confirm you can receive emails." },
  },
  {
    icon: "/icons/teams.png",
    ar: { title: "Microsoft Teams", desc: "افتح تطبيق Teams من المتصفح أو حمّله على جهازك. ستجد هناك قنوات فريقك ومحادثاتك." },
    en: { title: "Microsoft Teams", desc: "Open Teams from your browser or download the app. Your team channels and chats are waiting." },
  },
  {
    icon: "/icons/mename.png",
    ar: {
      title: "تطبيق الموارد البشرية",
      desc: "تطبيق تسجيل الحضور والانصراف اليومي. لا تقلق، تعليمات التحميل ورابط الدخول وكامل التفاصيل ستجدها في الخطوات القادمة.",
    },
    en: {
      title: "HR App",
      desc: "The daily attendance check-in/out app. Don't worry, download instructions, sign-in link, and full details will appear in the upcoming steps.",
    },
  },
];
